module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/ionicons.05acfdb568b3df49ad31355b19495d4a.woff";